<!-- Main content -->
<section class="content">
    <div class="container-fluid">
        <!-- <p><b>Kalaignar100 Winner List</b></p> -->
        <div class="card-header " style="background-color: white !important; text-align: center;">
            <div class="d-flex justify-content-center">
                <h4 class="font-weight-bold text-dark py " style=" text-align: center;">DASHBOARD</h4>

            </div>
        </div>
    
        <div class="row">
           
            <div class="col-lg-3 col-6">
            <div class="small-box bg-info" >
                <div class="inner">
                    <h3 data-toggle="modal" data-target="#myModal" style="cursor: pointer;">Course</h3>
                </div>
                <div class="icon">
                    <i class="fas fa-edit" style="font-size: 55px;top: 20px;"></i>
                </div>
                <a data-toggle="modal" data-target="#myModal" style="cursor: pointer;margin-top: 20px;" class="small-box-footer">Create <i class="fas fa-arrow-circle-right"></i></a>
            </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="small-box " style="background-color: #C71585;">
                    <div class="inner">
                        <h3 data-toggle="modal" data-target="#myModal1" style="cursor: pointer;color:white">Career Guidance</h3>
                    </div>
                    <div class="icon">
                        <i class="fas fa-clipboard" style="font-size: 55px;top: 20px;"></i>
                    </div>
                    <a data-toggle="modal" data-target="#myModal1" style="cursor: pointer;margin-top: 20px;" class="small-box-footer">Create<i class="fas fa-arrow-circle-right"></i></a>
                </div>
                </div>
                <div class="col-lg-3 col-6">
                    <div class="small-box" style="background-color: #483D8B">
                        <div class="inner">
                            <h3 style="color:white">{{ upcoming_course_count }}</h3>
    
                            <p style='text-align: center;color:white;'> No. of Upcoming Course(s)  </p>
                        </div>
                        <div class="icon">
                            <i class="fas fa-bell" style="font-size: 55px;top: 20px;"></i>
                        </div>
                    </div>
                    
                </div>
                <div class="col-lg-3 col-6">
                    <div class="small-box bg-success">
                        <div class="inner">
                            <h3>{{ completed_course_count }}</h3>
    
                            <p style='text-align: center;'> No. of Completed Course(s)  </p>
                        </div>
                        <div class="icon">
                            <i class="fas fa-lock" style="font-size: 55px;top: 20px;"></i>
                        </div>
                    </div>
                    
                </div>
                
        
            <!-- Second box -->
            <!-- <div class="col-lg-3 col-6">
                <div class="small-box bg-primary" >
                    <div class="inner">
                        <h3  data-toggle="modal" data-target="#myModal1" style="cursor: pointer;">Motivation speech</h3>
                    </div>
                    <div class="icon">
                        <i class="ion"></i>
                    </div>
                </div>
            </div> -->
        </div>

        <!-- Small boxes (Stat box) -->
        <!-- <div class="card-header " style="background-color: white !important;">
            <div class="d-flex justify-content-between">
                <h4 class="font-weight-bold text-dark py">DASHBOARD</h4>

            </div>
        </div> -->
        <!-- Small boxes (Stat box) -->
        <!-- <div class="row">
            <div class="col-lg-6 col-12"> -->
                <!-- small box -->
                <!-- <div class="small-box bg-info">
                    <div class="inner">
                        <h3>{{courses_assigned_to}}</h3>

                        <p style='text-align: center;'> No. of Upcoming Course(s)  </p>
                    </div>
                    <div class="icon">
                        <i class="ion "></i> -->
                    <!-- </div> -->
                    <!-- <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a> -->
                <!-- </div> -->
                
            <!-- </div>
            <div class="col-lg-6 col-12"> -->
                <!-- small box -->
                <!-- <div class="small-box bg-success">
                    <div class="inner">
                        <h3>{{courses_assigned_to}}</h3>

                        <p style='text-align: center;'> No. of Completed Course(s)  </p>
                    </div>
                    <div class="icon">
                        <i class="ion "></i>
                    </div> -->
                    <!-- <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a> -->
                <!-- </div>
                
            </div>
        </div> -->

        
    </div>
</section>
<!-- <app-course-assigned></app-course-assigned> -->


        <div class="modal fade" id="myModal">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">
                    <div class="card">

                        <div class="card-header show-header ">
                            <h3 class="card-title">CREATE COURSE</h3>
                            <button type="button" class="close" data-dismiss="modal"
                                (click)="Formreset()">&times;</button>
                        </div>

                        <div class="card-body">
                            <form class="register-form" [formGroup]='mentorcourse'
                                (ngSubmit)="postdata(mentorcourse)" autocomplete="off">
                                <div class="form-group row">
                                    <div class="form-group col-md-6">
                                        <input type="text" class="form-control" formControlName="student_id"
                                        [hidden]="true"/> 
                                        <label class="form-label">Course Name</label>
                                        <span
                                            class="required">*</span>   
                                        <input type="text" class="form-control" formControlName="course_name"
                                            placeholder="Enter Course Name" /> 
                                            <div style="color:red;"
                                            *ngIf="mentorcourse.get('course_name').touched &&  mentorcourse.get('course_name').value==''"
                                                class="invalid-msg">Please fill the field </div> 
                                                <!---<div *ngIf="mentorcourse.get('session_link').hasError('invalidLink')"  class="invalid-msg">Invalid Session Link.</div> -->
                                            </div>
                                    <div class="form-group col-md-6">
                                        <label>Subject</label><span class="required "> *</span>
                                        <!-- <input type="text" class="form-control" formControlName="course_topic"
                                        placeholder="Enter Course Topic" />  -->
                                        <select class="form-control" formControlName="course_topic"  placeholder="Select Subject">
                                            <option selected>Select Subject</option>
                                            <option>Civil</option>
                                            <option>Mechanical</option>
                                            <option>Computer</option>
                                            <option>IT</option>
                                                <option>Maths</option>
                                                <option>Physics</option>
                                                <option>Chemistry</option>
                                                <option>Botany</option>
                                                <option>Zoology</option>
                                                <option>Commerce</option>
                                                <option>Accountancy</option>
                                                <option>Economics</option>
                                                <option>History</option>
                                                <option>Civics</option>
                                                <option>Geography</option>
                                                <option>Aptitude</option>
                                                <option>General knowledge</option>
                                                <option>Electrical and Electronics</option>
                                                <option>Electronics and communication</option>
                                                <option>Others</option>
                                        </select>
                                        <div *ngIf="mentorcourse.get('course_topic').touched &&  mentorcourse.get('course_topic').value ==''"
                                        class="invalid-msg">Please fill the field </div>
                                </div>
                                    <div class="row" style="display:none">
                                        <input type="number" formControlName="user_id" />
                                    </div>
                                    <div class="form-group col-md-12">
                                        <label class="form-label">Description</label>
                                        <span
                                            class="required"></span>  
                                        <textarea type="text" class="form-control" formControlName="course_des"
                                            placeholder="Enter Course Description" ></textarea> 
                                        <!-- <div *ngIf="mentorcourse.get('session_link').touched &&  mentorcourse.get('session_link').value==''"
                                            class="invalid-msg">Please fill the field </div>
                                            <div *ngIf="mentorcourse.get('session_link').hasError('invalidLink')"  class="invalid-msg">Invalid Session Link.</div> -->
    </div>
                                   
                                </div>
                                <div class="form-group col-md-6">
                                    <label class="form-label">Mode of Course <span class="required">*</span></label><br>
                                    <div>
                                        <label class="mr-3">
                                            <input type="radio" formControlName="mode" value="Online" /> Online
                                        </label>
                                        <label>
                                            <input type="radio" formControlName="mode" value="Offline" /> Offline
                                        </label>
                                    </div>
                                    <div *ngIf="mentorcourse.get('mode').touched && mentorcourse.get('mode').value ==''" class="invalid-msg">
                                        Please select a mode
                                    </div>
                                </div>
                                
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label class="form-label">Course Date</label><span
                                            class="required">*</span>
                                        <input type="date" class="form-control" formControlName="course_date"
                                            placeholder="Enter Course Date" [min]="getCurrentDates()">
                                            <div *ngIf="mentorcourse.get('course_date').touched &&  mentorcourse.get('course_date').value==''"
                                            class="invalid-msg">Please fill the field </div>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label class="form-label">Course Time</label><span class="required">*</span>
                                        <input type="time" class="form-control" formControlName="course_time"
                                            placeholder="Enter Course Time" [min]="getCurrentTime()">
                                            <div *ngIf="mentorcourse.get('course_time').touched &&  mentorcourse.get('course_time').value==''"
                                            class="invalid-msg">Please fill the field </div>
                                    </div>
                                   
                                   
                                   
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6">

                                    <label class="form-label">
                                        Online Meeting Link:
                                        <a href="https://meet.google.com/landing" target="_blank">Google Meet</a>/
                                        <a href="https://app.zoom.us/wc" target="_blank">Zoom Meet</a>
                                        <span class="required"> *</span>
                                    </label>
                                    <input type="text" class="form-control" formControlName="session_link" placeholder="Enter Meet Link" />
                                    <div *ngIf="mentorcourse.get('session_link').touched && mentorcourse.get('session_link').value == ''" class="invalid-msg">
                                        Please fill the field
                                    </div>
                                    <!-- Uncomment if you want to show invalid link message -->
                                    <!-- <div *ngIf="mentorcourse.get('session_link').hasError('invalidLink')" class="invalid-msg">Invalid Session Link.</div> -->
                                </div>
                                <div class="col-md-6">
                                    <label>Photo <span class="required">*</span></label>
                                    <input type="file" formControlName="image" id="file"  class="form-control" (change)="selectFiles($event)" />
                                    <p style="color:black; margin-bottom: unset;">Note: File size should be 60 kb and format jpeg, jpg, png</p>
                                
                                    <!-- Display the selected image or a default image if none is selected -->
                                    <!-- <img [src]="imageSrc || 'images/course.jpg'" 
                                         style="width:100px;height:100px;display:block;margin-top:10px;" 
                                         alt="Course Image"/> -->
                                         
                                    <div style="color:red;" 
                                         *ngIf="mentorcourse.get('image')?.touched && (mentorcourse.get('image')?.hasError('required') || mentorcourse.get('image')?.hasError('imageSizeExceeded'))">
                                        Please upload a valid image 
                                    </div>
                                </div>
                            </div>

                                
                              
                                <div class="form-group">
                                    <div>
                                        <label>Comments</label> 
                                        <textarea type="text" class="form-control" formControlName="comments"
                                            placeholder=" Enter Comments"></textarea>
                                             <!-- <div *ngIf="mentorcourse.get('comments').touched &&  mentorcourse.get('comments').value==''"
                                            class="invalid-msg">Please fill the field </div> -->
                                           </div>
                                </div>

                                <div class="d-flex justify-content-center">
                                    <div style="width:200px">
                                        <button class="btn btn-primary btn btn-block" [disabled]="mentorcourse.invalid">Submit</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="myModal1">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">
                    <div class="card">

                        <div class="card-header show-header ">
                            <h3 class="card-title"> CREATE CAREER GUIDANCE</h3>
                            <button type="button" class="close" data-dismiss="modal"
                                (click)="Formreset()">&times;</button>
                        </div>

                        <div class="card-body">
                            <form class="register-form" [formGroup]='mentorcourse_motivational'
                                (ngSubmit)="postdata_motivation(mentorcourse_motivational)" autocomplete="off">
                                <div class="form-group row">
                                    <div class="col-sm-6 mb-3 mb-sm-0">

                                        <!-- <input type="text" class="form-control" formControlName="student_id"
                                        [hidden]="true"/>  -->
                                        <label>Topic </label><span class="required "> *</span>
                                           <input type="text" class="form-control" formControlName="course_name"
                                           placeholder="Enter Topic">
                                         <div *ngIf="mentorcourse_motivational.get('course_name').touched &&  mentorcourse_motivational.get('course_name').value ==''"
                                            class="invalid-msg">Please fill the field </div> 
                                    </div>
                                    <div class="row" style="display:none">
                                        <input type="number" formControlName="user_id" />
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label class="form-label">Description</label>
                                        <span
                                            class="required"></span>  
                                        <textarea type="text" class="form-control" formControlName="course_des"
                                            placeholder="Enter Description" ></textarea> 
                                        <div *ngIf="mentorcourse_motivational.get('course_des').touched &&  mentorcourse_motivational.get('course_des').value==''"
                                            class="invalid-msg">Please fill the field </div>
                                            <div *ngIf="mentorcourse_motivational.get('course_des').hasError('invalidLink')"  class="invalid-msg">Invalid Session Link.</div> 
    </div>
                                
                                </div>
                                <div class="form-group col-md-6">
                                    <label class="form-label">Mode of Course <span class="required">*</span></label><br>
                                    <div>
                                        <label class="mr-3">
                                            <input type="radio" formControlName="mode" value="Online" /> Online
                                        </label>
                                        <label>
                                            <input type="radio" formControlName="mode" value="Offline" /> Offline
                                        </label>
                                    </div>
                                    <div *ngIf="mentorcourse_motivational.get('mode').touched && mentorcourse_motivational.get('mode').value ==''" class="invalid-msg">
                                        Please select a mode
                                    </div>
                                </div>
                                
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label class="form-label">Event Date</label><span
                                            class="required">*</span>
                                        <input type="date" class="form-control" formControlName="course_date"
                                            placeholder="Enter Course Date" [min]="getCurrentDates()">
                                        <div *ngIf="mentorcourse_motivational.get('course_date').touched &&  mentorcourse_motivational.get('course_date').value==''"
                                            class="invalid-msg">Please fill the field </div> 
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label class="form-label">Event Time</label><span class="required">*</span>
                                        <input type="time" class="form-control" formControlName="course_time"
                                            placeholder="Enter Course Time" [min]="getCurrentDates()">
                                        <div *ngIf="mentorcourse_motivational.get('course_time').touched &&  mentorcourse_motivational.get('course_time').value==''"
                                            class="invalid-msg">Please fill the field </div> 
                                    </div>
                                   
                                   

                                </div>
                                <div class="form-group row">
                                    <div class="form-group col-md-6">
                                        <label class="form-label">
                                            Online Meeting Link:
                                            <a href="https://meet.google.com/landing" target="_blank">Google Meet</a>/
                                            <a href="https://app.zoom.us/wc" target="_blank">Zoom Meet</a>
                                            <span class="required"> *</span>
                                        </label>
                                        <input type="text" class="form-control" formControlName="session_link" placeholder="Enter Online Meeting link" /> 
                                        <div *ngIf="mentorcourse_motivational.get('session_link').touched && mentorcourse_motivational.get('session_link').value==''"
                                            class="invalid-msg">Please fill the field </div> 
                                        <!-- <div *ngIf="mentorcourse_motivational.get('session_link').hasError('invalidLink')" class="invalid-msg">Invalid Session Link.</div> -->
                                    </div>
                                    <div class="col-md-6">
                                        <label>Photo <span class="required">*</span></label>
                                        <input type="file" formControlName="image" id="file"  class="form-control" (change)="selectFiles($event)" />
                                        <p style="color:black; margin-bottom: unset;">Note: File size should be 60 kb and format jpeg, jpg, png</p>
                                    
                                        <!-- Display the selected image or a default image if none is selected -->
                                        <!-- <img [src]="imageSrc || 'images/course.jpg'" 
                                             style="width:100px;height:100px;display:block;margin-top:10px;" 
                                             alt="Course Image"/> -->
                                             
                                        <div style="color:red;" 
                                             *ngIf="mentorcourse.get('image')?.touched && (mentorcourse.get('image')?.hasError('required') || mentorcourse.get('image')?.hasError('imageSizeExceeded'))">
                                            Please upload a valid image 
                                        </div>
                                    </div>
                                    
</div>
                                <div class="form-group">
                                    <div>
                                        <label>Comments</label> 
                                        <textarea type="text" class="form-control" formControlName="comments"
                                            placeholder="Comments"></textarea>
                                             <!-- <div *ngIf="mentorcourse_motivational.get('comments').touched &&  mentorcourse_motivational.get('comments').value==''"
                                            class="invalid-msg">Please fill the field </div> -->
                                           </div>
                                </div>

                                <div class="d-flex justify-content-center">
                                    <div style="width:200px">
                                        <button class="btn btn-primary btn btn-block" [disabled]="mentorcourse_motivational.invalid">Submit</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

      

 

<!-- /.content -->